import Cookies from 'universal-cookie';

const checkIsOpenConnection = ({ monitoringStatus, userIdentity }) => {
  const cookies = new Cookies();
  const organization = cookies.get('organization');
  const isHost = userIdentity?.isHost;
  const isOperator = userIdentity?.isOperator;

  if (isOperator) return monitoringStatus?.status === 'CLOCKED_IN_ACTIVE';
  if (isHost && organization?.region !== 'MY') return true;

  return false;
};

export default checkIsOpenConnection;
